import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section section-hero is-center is-vertical-align" }
const _hoisted_2 = { class: "section-hero-bubbles" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"hide-xs col-1-md col-2-lg\"></div><div class=\"col-12 col-10-md col-8-lg text-center\"><figure class=\"img img-brand-md\"></figure><h1>Sweet coin for furry soldiers</h1><p class=\"lead\"> One of the tokens of the BearzVerse universe used by bears as an internal currency and medium of exchange. Will be used in the game on BSC </p></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
      [_vShow, _ctx.active]
    ]),
    _hoisted_3
  ]))
}